/** @format */

import { END_POINT } from "utils";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "./axios";
import {
  AccountCodeForm,
  AccountCodeQuery,
  AccountCodeUpdatePayload,
} from "types";

const buildQueryString = (params?: AccountCodeQuery) => {
  if (!params) return "";
  const search = new URLSearchParams();
  if (params.page) search.append("page", String(params.page));
  if (params.pageSize) search.append("limit", String(params.pageSize));
  if (params.type) search.append("type", params.type);
  if (params.search) search.append("q", params.search);
  const hasSort =
    Array.isArray(params.sortModel) && params.sortModel.length > 0;
  if (hasSort) {
    search.append("sort", JSON.stringify(params.sortModel));
  }
  const hasFilters =
    params.filterModel &&
    typeof params.filterModel === "object" &&
    Object.keys(params.filterModel).length > 0;
  if (hasFilters) {
    search.append("filters", JSON.stringify(params.filterModel));
  }
  const qs = search.toString();
  return qs ? `?${qs}` : "";
};

const appendTypeParam = (url: string, type?: string) => {
  if (!type) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${new URLSearchParams({ type }).toString()}`;
};

export const accountCodeService = {
  list: async (params?: AccountCodeQuery) => {
    const rs = await getRequest(
      `${END_POINT.ACCOUNT_CODES.LIST}${buildQueryString(params)}`,
    );
    return rs.data;
  },
  show: async (id: number | string, type?: string) => {
    const rs = await getRequest(
      appendTypeParam(`${END_POINT.ACCOUNT_CODES.LIST}/${id}`, type),
    );
    return rs.data;
  },
  store: async (payload: AccountCodeForm, type?: string) => {
    const rs = await postRequest(
      appendTypeParam(
        END_POINT.ACCOUNT_CODES.LIST,
        type,
      ),
      payload,
    );
    return rs.data;
  },
  update: async (payload: AccountCodeUpdatePayload, type?: string) => {
    const rs = await patchRequest(
      appendTypeParam(
        `${END_POINT.ACCOUNT_CODES.LIST}/${payload.id}`,
        type,
      ),
      payload,
    );
    return rs.data;
  },
  destroy: async (id: number | string, type?: string) => {
    const rs = await deleteRequest(
      appendTypeParam(`${END_POINT.ACCOUNT_CODES.LIST}/${id}`, type),
    );
    return rs.data;
  },
};
